/*
 * Module for the the View Request page 
*/
rs.module("ui/framework/content/portalrequests/viewrequest",

    ["controls/components/event-banner"],

    function (eventBanner) {

        // Initialize a given document upload control
        function initializeDocumentUpload(documentUpload, checkMark) {

            // show a clock while the document is uploading
            documentUpload.onFileUploadStarted(function (success) {
                $.js(checkMark).addClass("_uploading");
                eventBanner.removeAllMessages();
            });

            // if the file was uploaded successfully, show a "pending" checkmark
            documentUpload.onFileUploadComplete(function (success) {
                $.js(checkMark).removeClass("_uploading").toggleClass("_pending-checked", success);
            });

            // when the file is removed, reset checkmark to an empty circle
            documentUpload.onFileRemoved(function () {
                if (documentUpload.getChosenFiles().length == 0) {
                    $.js(checkMark).removeClass("_pending-checked _uploading");
                }
            });

            // when clicking an unsubmitted document checkmark, 
            // trigger a click on the upload control to open the file explorer
            $.js(checkMark).on("click", function () {
                documentUpload.triggerClick();
            });
        }

        // Exported public API
        var exports = {
            initializeDocumentUpload
        };

        return exports;
    }
);